/**
 * OCAMAR — Wishlist (favoritos)
 * Guarda los productos que la clienta marca con el corazon en el navegador
 * (localStorage). No requiere cuenta ni app externa.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ocamar:wishlist';

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* modo privado o almacenamiento lleno: el corazon sigue funcionando en la sesion */
    }
    document.dispatchEvent(new CustomEvent('ocamar:wishlist:change', { detail: { items: list } }));
  }

  var Wishlist = {
    all: read,
    has: function (handle) {
      return read().indexOf(handle) !== -1;
    },
    toggle: function (handle) {
      var list = read();
      var index = list.indexOf(handle);
      if (index === -1) {
        list.unshift(handle);
      } else {
        list.splice(index, 1);
      }
      write(list);
      return index === -1;
    },
    remove: function (handle) {
      var list = read().filter(function (h) { return h !== handle; });
      write(list);
    }
  };

  window.OcamarWishlist = Wishlist;

  function updateCounts() {
    var count = read().length;
    document.querySelectorAll('[data-ocamar-wishlist-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
  }

  /* ---------------------------------------------------------------- boton */

  class OcamarWishlistButton extends HTMLElement {
    connectedCallback() {
      this.handle = this.getAttribute('product-handle');
      this.button = this.querySelector('button');
      if (!this.handle || !this.button) return;

      this.onClick = this.onClick.bind(this);
      this.sync = this.sync.bind(this);

      this.button.addEventListener('click', this.onClick);
      document.addEventListener('ocamar:wishlist:change', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onClick);
      document.removeEventListener('ocamar:wishlist:change', this.sync);
    }

    onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      var added = Wishlist.toggle(this.handle);
      if (added) {
        this.button.classList.add('is-bouncing');
        setTimeout(function (btn) { btn.classList.remove('is-bouncing'); }, 420, this.button);
      }
    }

    sync() {
      var saved = Wishlist.has(this.handle);
      this.button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      this.button.setAttribute(
        'aria-label',
        saved ? 'Quitar de favoritos' : 'Guardar en favoritos'
      );
      this.classList.toggle('is-saved', saved);
      updateCounts();
    }
  }

  if (!customElements.get('ocamar-wishlist-button')) {
    customElements.define('ocamar-wishlist-button', OcamarWishlistButton);
  }

  /* ------------------------------------------------------- pagina favoritos */

  function money(cents) {
    try {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'COP',
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {
      return '$' + Math.round(cents / 100).toLocaleString('es-CO');
    }
  }

  class OcamarWishlistGrid extends HTMLElement {
    connectedCallback() {
      this.render = this.render.bind(this);
      document.addEventListener('ocamar:wishlist:change', this.render);
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('ocamar:wishlist:change', this.render);
    }

    async render() {
      var handles = Wishlist.all();
      var grid = this.querySelector('[data-grid]');
      var empty = this.querySelector('[data-empty]');
      if (!grid || !empty) return;

      if (handles.length === 0) {
        grid.innerHTML = '';
        grid.hidden = true;
        empty.hidden = false;
        return;
      }

      empty.hidden = true;
      grid.hidden = false;

      var products = await Promise.all(
        handles.map(function (handle) {
          return fetch('/products/' + encodeURIComponent(handle) + '.js')
            .then(function (res) { return res.ok ? res.json() : null; })
            .catch(function () { return null; });
        })
      );

      grid.innerHTML = products
        .map(function (product, index) {
          if (!product) {
            /* el producto ya no existe: lo sacamos silenciosamente */
            Wishlist.remove(handles[index]);
            return '';
          }
          var image = product.featured_image
            ? product.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2')
            : '';
          var soldOut = product.available === false;
          return [
            '<article class="ocamar-wishlist__card">',
            '  <a class="ocamar-wishlist__media" href="/products/' + product.handle + '">',
            image
              ? '    <img src="' + image + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="600" height="600">'
              : '    <span class="ocamar-wishlist__media-empty" aria-hidden="true"></span>',
            soldOut ? '    <span class="ocamar-wishlist__badge">Agotado</span>' : '',
            '  </a>',
            '  <div class="ocamar-wishlist__info">',
            '    <a class="ocamar-wishlist__title" href="/products/' + product.handle + '">' + product.title + '</a>',
            '    <p class="ocamar-wishlist__price">' + money(product.price) + '</p>',
            '    <div class="ocamar-wishlist__actions">',
            soldOut
              ? '      <button type="button" class="ocamar-wishlist__add" disabled>Agotado</button>'
              : '      <button type="button" class="ocamar-wishlist__add" data-add="' + product.variants[0].id + '">Agregar al carrito</button>',
            '      <button type="button" class="ocamar-wishlist__remove" data-remove="' + product.handle + '" aria-label="Quitar de favoritos">Quitar</button>',
            '    </div>',
            '  </div>',
            '</article>'
          ].join('\n');
        })
        .join('\n');

      grid.querySelectorAll('[data-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          Wishlist.remove(btn.getAttribute('data-remove'));
        });
      });

      grid.querySelectorAll('[data-add]').forEach(function (btn) {
        btn.addEventListener('click', async function () {
          btn.disabled = true;
          btn.textContent = 'Agregando…';
          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-add')), quantity: 1 }] })
            });
            btn.textContent = '¡Agregado!';
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
            setTimeout(function () { window.location.href = '/cart'; }, 600);
          } catch (e) {
            btn.disabled = false;
            btn.textContent = 'Agregar al carrito';
          }
        });
      });
    }
  }

  if (!customElements.get('ocamar-wishlist-grid')) {
    customElements.define('ocamar-wishlist-grid', OcamarWishlistGrid);
  }

  document.addEventListener('DOMContentLoaded', updateCounts);
  updateCounts();
})();
